document.addEventListener('DOMContentLoaded', function () {
	const productGridContainer = document.getElementById('ProductGridContainer');
	if (!productGridContainer) return;

	productGridContainer.addEventListener('click', function (event) {
		const btn = event.target.closest('.load-more_btn');
		if (!btn) return;
		loadMoreProducts(btn);
	});

	async function getNextPage(url) {
		try {
			const res = await fetch(url);
			if (!res.ok) throw new Error(`Error HTTP: ${res.status}`);
			return await res.text();
		} catch (error) {
			console.error('Error loading page', error);
			return null;
		}
	}

	async function loadMoreProducts(btn) {
		const productsOnPage = document.getElementById('product-grid');
		const loadMoreWrapper = document.getElementById('collection_load_more');
		const spinner = loadMoreWrapper ? loadMoreWrapper.querySelector('.load-more_spinner') : null;
		const paginationMobile = document.querySelector('.pagination_mobile');

		if (!productsOnPage) return;

		const nextUrl = productsOnPage.dataset.nextUrl;
		if (!nextUrl) return;

		if (paginationMobile) paginationMobile.style.display = 'none';
		btn.style.display = 'none';
		if (spinner) spinner.style.display = 'block';

		const nextPage = await getNextPage(nextUrl);
		if (!nextPage) {
			if (spinner) spinner.style.display = 'none';
			btn.style.display = 'block';
			return;
		}

		const parser = new DOMParser();
		const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
		const nextGrid = nextPageDoc.getElementById('product-grid');

		if (!nextGrid) {
			if (spinner) spinner.style.display = 'none';
			return;
		}

		const newProducts = nextGrid.querySelectorAll('.grid__item');

		if (newProducts.length === 0) {
			if (spinner) spinner.style.display = 'none';
			return;
		}

		newProducts.forEach((product) => {
			productsOnPage.appendChild(product.cloneNode(true));
		});

		const newNextUrl = nextGrid.dataset.nextUrl || '';
		productsOnPage.dataset.nextUrl = newNextUrl;

		if (spinner) spinner.style.display = 'none';
		if (newNextUrl) {
			btn.style.display = 'block';
		}
	}
});